import React, { useState, useEffect } from "react";
import "./style.css";
import AOS from 'aos';
import { getAnalytics, logEvent } from "firebase/analytics";
import { Link } from 'react-router-dom';
import { Header_New } from "../../../components/Header_new"; 

const Explanation = () => {
  const analytics = getAnalytics();
  logEvent(analytics, 'explanation');

  const [randomMargins, setRandomMargins] = useState([]);
  const contentBlocks = [
    {
      headerText: "1. Was wir bezwecken wollen",
      quote: "Revolution im Lesen: Unser Weg zur Leseförderung",
      paraText: "In einer Zeit, in der junge Menschen zunehmend Schwierigkeiten beim Lesen und Schreiben haben, bringt unser Projekt eine revolutionäre Lösung: Eine interaktive Leseplattform, die das Lesen für Kinder und Jugendliche wieder attraktiv macht. Wir verstehen die Herausforderungen des digitalen Zeitalters und reagieren darauf, indem wir das Lesen 'gamifizieren'. Unsere Plattform nutzt künstliche Intelligenz (KI), um Benutzern eine einzigartige, dynamische Geschichte zu bieten, die sich mit ihren Entscheidungen entwickelt. Ziel ist es, das Interesse am Lesen zu wecken und gleichzeitig die Lesefähigkeiten zu verbessern."
    },
    {
      headerText: "2. Was noch kommt",
      quote: "Die Zukunft des interaktiven Lesens: Nächste Schritte",
      paraText: "Unsere Vision hört nicht bei der aktuellen Umsetzung auf. Wir planen, unsere interaktive Leseplattform weiterzuentwickeln. Zukünftige Erweiterungen umfassen Optionen wie vorgegebene Entscheidungen, um den Verlauf der Geschichte zu beeinflussen. Eine weitere spannende Entwicklung ist das kollaborative Lesen: Freunde können zusammen eine Geschichte erleben, wobei jeder eine andere Hauptfigur steuert und ihre Entscheidungen die gemeinsame Geschichte beeinflussen. Wir streben danach, die Plattform kontinuierlich zu verbessern und neue, innovative Funktionen hinzuzufügen, um das Leseerlebnis noch fesselnder zu gestalten."
    },
    {
      headerText: "3. Wie das Projekt funktioniert",
      quote: "Wie kann man unser Projekt benutzen",
      paraText: "Unsere Plattform ist mehr als nur ein digitales Buch. Sie beginnt mit einer Geschichte, die von KI unterstützt wird. Am Ende jeder Seite steht eine Frage, und der Leser entscheidet, wie es weitergeht, indem er seine Antwort eingibt. Diese Antwort wird an unser Backend gesendet, wo sie verarbeitet wird, und die KI entwickelt die Geschichte weiter bis zur nächsten Entscheidung. Durch diese Methode wird jeder Lesevorgang einzigartig und persönlich. Unser System nutzt fortschrittliche Algorithmen, um sicherzustellen, dass jede Entscheidung nahtlos in den Fortgang der Geschichte integriert wird und ein kohärentes Leseerlebnis bietet. Alle Geschichten werden mit eurer Fantasie beeinflusst und können über die Realität hinaus verändert werden."
    },
    {
      headerText: "4. Technische Einblicke",
      quote: "Innovative Technologien: Das Herzstück unserer Interaktiven Leseplattform",
      paraText: "Unsere Plattform ist das Ergebnis der Integration moderner Technologien, konzipiert für eine effiziente und benutzerfreundliche Leseerfahrung. Im Kern verwenden wir React JS für unser Frontend, um eine intuitive und ansprechende Benutzeroberfläche zu schaffen. Dies erleichtert die Navigation und Interaktion auf der Plattform und sorgt für ein angenehmes Nutzererlebnis. Im Backend setzen wir auf Python Django, bekannt für seine Zuverlässigkeit und Effizienz. Django bewältigt mühelos die Verarbeitung von Benutzereingaben und die Steuerung der Interaktionen mit der KI. Für die Inhaltsentwicklung und das Herzstück unserer Plattform, die Erstellung der Geschichten, verwenden wir GPT-3.5 von OpenAI. Diese fortschrittliche KI-Technologie ermöglicht es uns, personalisierte und dynamische Geschichten zu generieren, die auf den Entscheidungen der Nutzer basieren. Die Kombination aus React JS, Python Django und GPT-3.5 bildet ein leistungsfähiges und benutzerorientiertes System, das unsere Mission unterstützt, das Lesen für Kinder und Jugendliche durch den Einsatz innovativer Technologien attraktiver zu gestalten."
    }
  ];

  const getRandomMargin = () => {
    return Math.floor(Math.random() * 2000) - 1000 + 'px';
  };
  useEffect(() => {
    AOS.init();
    setRandomMargins([
      getRandomMargin(),
      getRandomMargin(),
      getRandomMargin(),
      getRandomMargin()
    ]);
  }, []);
  return (
    <div className="homepage">
      <div className="main-content">
      <Header_New></Header_New>
          {/* Background Animation Layer */}
        <div className="background-animation">
          <div class="area" >
              <ul class="circles">
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
              </ul>
          </div >
        </div>
        <Link to="/bookchoice" className="try-it-banner">
          Probier es
        </Link>
        <div className="content-section">
          {contentBlocks.map((block, index) => (
            <div
              key={index}
              className="content-block"
              data-aos="fade-up"
              style={{ marginLeft: randomMargins[index] }}
            >
              {block.headerText && <div className="header-text">{block.headerText}</div>}
              {block.quote && <div className="quote">{block.quote}</div>}
              {block.paraText && <div className="para-text">{block.paraText}</div>}
            </div>
          ))}
        </div>
      </div>
      <div className="mobile-warning">
          Bitte drehen sie ihr Gerät<img src="https://firebasestorage.googleapis.com/v0/b/weread-45736.appspot.com/o/background%2FturnLandscape.png?alt=media&token=5c863abc-d04b-4bb1-9639-53b4056b88f5"></img>
      </div>
    </div>
  );
};
export default Explanation;